// ActionDropdownFacture.jsx
import { useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { FaEdit, FaTrash, FaFilePdf, FaEye, FaVoicemail, FaExchangeAlt, FaPlus } from "react-icons/fa";

const ActionDropdownFacture = ({ f, navigate, handleDeleteClick, openPdf, isOpen, onToggle, onClose, openRelance, role = "user" }) => {
    const btnRef = useRef(null);
    const menuRef = useRef(null);
    const [menuStyles, setMenuStyles] = useState({});

    const handleToggle = () => {
        if (!isOpen && btnRef.current) {
            const rect = btnRef.current.getBoundingClientRect();
            setMenuStyles({
                position: "absolute",
                top: rect.bottom + window.scrollY,
                left: rect.right - 176 + window.scrollX,
                minWidth: "160px",
                zIndex: 9999,
            });
        }
        onToggle();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !btnRef.current.contains(event.target)
            ) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, onClose]);

    const consulterLink = role === "comptable"
        ? `/EspaceCompta/factures/consulter/${f.id}`
        : `/EspaceClient/facture/consulter/${f.id}`;

    return (
        <>
            <button
                ref={btnRef}
                onClick={handleToggle}
                className="px-2 py-1 bg-gray-100 rounded hover:bg-gray-300 text-lg font-bold"
            >
                ⋮
            </button>

            {isOpen && ReactDOM.createPortal(
                <div ref={menuRef} style={menuStyles} className="bg-white border border-gray-200 rounded shadow-lg">
                    {/* Consulter */}
                    <button
                        onClick={() => { navigate(consulterLink); onClose(); }}
                        className="flex items-center w-full px-3 py-2 text-sm font-bold text-blue-600 hover:bg-blue-100"
                    >
                        <FaEye className="mr-2" /> Consulter
                    </button>

                    {/* Actions visibles uniquement si rôle != comptable */}
                    {role !== "comptable" && (
                        <>
                            <button
                                onClick={() => { navigate(`/EspaceClient/facture/modifier/${f.id}`); onClose(); }}
                                className="flex items-center w-full px-3 py-2 text-sm font-bold text-gray-600 hover:bg-gray-100"
                            >
                                <FaEdit className="mr-2" /> Modifier
                            </button>

                            <button
                                onClick={() => { handleDeleteClick(f); onClose(); }}
                                className="flex items-center w-full px-3 py-2 text-sm font-bold text-red-600 hover:bg-red-100"
                            >
                                <FaTrash className="mr-2" /> Supprimer
                            </button>

                            <button
                                onClick={() => { navigate(`/EspaceClient/avoirs/ajouter/${f.id}`); onClose(); }}
                                className="flex items-center w-full px-3 py-2 text-sm font-bold text-purple-600 hover:bg-purple-100"
                            >
                                <FaPlus className="mr-2" /> Créer Avoir
                            </button>

                            <button
                                onClick={() => { /* Transformer action si nécessaire */ onClose(); }}
                                className="flex items-center w-full px-3 py-2 text-sm font-bold text-purple-600 hover:bg-purple-100"
                            >
                                <FaExchangeAlt className="mr-2" /> Transformer
                            </button>
                        </>
                    )}

                    {/* PDF */}
                    <button
                        onClick={() => { openPdf(f.id); onClose(); }}
                        className="flex items-center w-full px-3 py-2 text-sm font-bold text-green-600 hover:bg-green-100"
                    >
                        <FaFilePdf className="mr-2" /> PDF
                    </button>

                    {/* Relance */}
                    {openRelance && role !== "comptable" && (
                        <button
                            onClick={() => { openRelance(f); onClose(); }}
                            className="flex items-center w-full px-3 py-2 text-sm font-bold text-amber-950 hover:bg-green-100"
                        >
                            <FaVoicemail className="mr-2" /> Relancer
                        </button>
                    )}
                </div>,
                document.body
            )}
        </>
    );
};

export default ActionDropdownFacture;
